import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/selling/LeftMenu';
import ContactUs from '../components/ContactUs';
import SellYourMachineIn30Days from '../components/SellYourMachineIn30Days';

const BargainAuction = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('selling'),
      url: '/content/selling/bargain-auction',
    },
    {
      label: 'Pazarlık Usulü Açık Artırma',
      url: '/content/selling/bargain-auction',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="bargain-auction" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Pazarlık Usulü Açık Artırma</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  Pazarlık Usulü yöntemi ile satışa çıkan makinalar, önceden belirlenmiş olan "Rezerv Fiyatı", "Hemen Al" ve "Başlangıç Fiyatı" belirlenmiş şekilde satışa hazır durumdadır.
                  Makinaları satın almak isteyen alıcılar, teklif verebilir ya da makina ilan sayfasında belirtilen "Hemen Al" butonuna tıklayarak belirlenen fiyatı ödeyerek kolayca makina sahibi olabilirler.
                  Listelen makine "Hemen Al" seçeneğiyle satılırsa açık artırmanın bitiş tarihinden önce açık artırma sonlandırılır.
                </p>
                <p>
                  Pazarlık Usulü Açık Artırma satıcıya ve alıcıya son fiyat için pazarlık yapma olanağı sunmaktadır.
                  Açık artırmanın sonunda verilen en yüksek telif 'Rezerv Fiyatı' geçmemişse, açık artırma sırasında en yüksek teklifi veren alıcıya satıcı arzuladığı fiyatı iletebilir.
                  Alıcı buna karşılık olarak teklifi reddedebilir, kabul edebilir veya karşı teklif gönderebilir.
                  Bu sayede online bir pazarlık ortamı oluşturulur.
                </p>
                <p>
                  Örneğin rezerv fiyatı 80.000 Euro olan makinaya verilen en yüksek teklif 75.000 Euro olursa, satıcı 75.000 Euro teklifi veren alıcıya 80.000 Euro'luk bir teklif verebilir.
                  Alıcı bu durumda teklifi reddebilir, kabul edebilir veya karşı teklif olarak 77.000 Euro teklif edebilir.
                </p>
                <p>
                  Anlaşmaya varılmaması durumunda makina tekrar satışa çıkartılır.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Rezerv Fiyatı</h2>
              </div>
              <div className="col-15">
                <p>
                  Makinanın satışa çıkmadan önce satıcı tarafından  belirlenen minimum satış fiyatıdır.
                  Satıcının makinasını satmak istediği en düşük fiyattır.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Hemen Al Fiyatı</h2>
              </div>
              <div className="col-15">
                <p>
                  Hemen Al Fiyatı makinanın satıcı ve müzayede yöneticisi tarafından belirlenen makul satış fiyatıdır.
                  Makinanın ilan sayfasında bulunan Hemen Al butonuna tıklarsanız bu fiyatı vermeyi kabul etmiş olursunuz böylece açık artırma sonlanır ve makinayı satın almış kabul edilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Başlangıç Fiyatı</h2>
              </div>
              <div className="col-15">
                <p>
                  Makinanın açık artıma başlangıcındaki fiyatıdır. Müzayede yöneticisi tarafından belirlenir.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Ulusal Alıcı Havuzu</h2>
              </div>
              <div className="col-15">
                <p>
                  iyiMakina.com kullanıcıları; bilgisayarları, cep telefonları veya tabletleri aracılığıyla açık artırmalara istediği yerden, istediği saatte online olarak katılabilirler.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Doğrudan ve Güvenilir Satış</h2>
              </div>
              <div className="col-15">
                <p>
                  İkinci el iş makinalarınızı arada aracı olmadan, doğrudan alıcılarla buluşturan iyiMakina.com'da; hızlı, şeffaf ve güvenilir yöntemlerle makinanızı kolayca satabilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Saatler İçinde Satış ve Devir</h2>
              </div>
              <div className="col-15">
                <p>
                  iyiMakina.com'da makina satmak isteyen kullanıcılar; İster Pazarlık usulü ile, ister Zaman Ayarlı Açık Arıtrma ile makinalarını hızlı, güvenilir ve değerinde satarlar.
                </p>
              </div>
            </div>
            <SellYourMachineIn30Days />
            <ContactUs about="Açık Artırma Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

BargainAuction.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Pazarlık Usulü Açık Artırma',
    },
  };
};

BargainAuction.Layout = Layout;

export default withTranslation('common')(BargainAuction);
